<template>
    <section id="about" class="section about">
        <div class="container_big">
            <div class="about__inner">
                <div class="about__title">
                    <app-title>ОБО МНЕ</app-title>
                </div>
                <div class="about__inner-container">
                    <div class="about__info">
                        <div class="about__info-block">
                            <p class="about__name">Привет! Меня зовут Диана Фёдорова</p>
                            <p class="about__descr">Я тренер и специалист по питанию. Помогаю людям в модификации образа
                                жизни, коррекции питания и веса</p>
                        </div>
                        <div class="about__info-block">
                            <p class="about__name">С кем я работаю?</p>
                            <ul class="about__list">
                                <li>
                                    <p class="about__descr">Беременные девушки и девушки после родов</p>
                                </li>
                                <li>
                                    <p class="about__descr">Люди с недостатком мышечной массы и отеками </p>
                                </li>
                                <li>
                                    <p class="about__descr">Люди с лишним весом</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="about__photo">
                        <img src="@/assets/img/about-section.png" alt="A im">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.about {
    &__title {
        margin-left: -195px;
        background: #FBF8F4;
        padding-top: 20px;
        @media (max-width: 1919px) {
            margin-left: -110px;
        }
        @media (max-width: 1439px) {
            margin-left: 0;
            padding: 0;
        }
        @media (max-width: 767px) {
            margin: 0 auto;
            text-align: center;
        }
    }

    &__inner {
        border: 1.5px solid #CDCDCD;
        border-radius: 0 0 40px 40px;
        padding: 54px 165px 150px 103px;
        border-top: none;
        @media (max-width: 1919px) {
            padding: 54px 50px 150px;
        }
        @media (max-width: 1439px) {
            border: none;
            padding: 54px 0 150px;
        }
        @media (max-width: 767px) {
            padding-bottom: 100px;
        }
        @media (max-width: 479px) {
            padding-bottom: 60px;
        }
    }

    &__inner-container {
        display: flex;
        justify-content: space-between;
        @media (max-width: 1439px) {
            margin-top: 140px;
        }
        @media (max-width: 1023px) {
            margin-top: 75px;
        }
        @media (max-width: 767px) {
            flex-direction: column-reverse;
            align-items: center;
            margin-top: 30px;
            gap: 65px;
        }
    }

    &__name {
        font-family: 'Montserrat', serif;
        font-style: normal;
        font-weight: 600;
        font-size: 28px;
        line-height: 1.2;
        letter-spacing: 0.025em;
        color: #724724;
        @media (max-width: 1023px) {
            font-size: 24px;
        }
        @media (max-width: 767px) {
            font-size: 22px;
        }
        @media (max-width: 479px) {
            font-size: 20px;
        }
    }

    &__descr {
        font-family: 'Montserrat', serif;
        font-style: normal;
        font-weight: 300;
        font-size: 24px;
        line-height: 150%;
        color: #534340;
        @media (max-width: 1023px) {
            font-size: 20px;
            line-height: 1.5;
        }
        @media (max-width: 767px) {
            font-size: 18px;
        }
        @media (max-width: 479px) {
            font-size: 16px;
        }
    }

    &__photo {
        width: 540px;
        height: 764px;
        padding: 20px;
        border-radius: 270px;
        border: 1.5px solid #CDCDCD;
        position: relative;

        &:before {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(calc(100% + 2px), -50%);
            width: 165px;
            height: 1px;
            background: #cdcdcd;
            @media (max-width: 1919px) {
                width: 50px;
            }
            @media (max-width: 1439px) {
                width: 40px;
            }
            @media (max-width: 767px) {
                display: none;
            }
        }

        & img {
            border-radius: 270px;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        @media (max-width: 1439px) {
            width: 396px;
            height: 561px;
            padding: 15px;
        }
        @media (max-width: 1023px) {
            width: 264px;
            height: 374px;
            padding: 10px;
        }
    }

    &__info {
        display: flex;
        flex-direction: column;
        gap: 80px;
        max-width: 640px;
        margin-top: 187px;
        @media (max-width: 1439px) {
            margin-top: 0;
            max-width: 480px;
        }
        @media (max-width: 1023px) {
            max-width: 400px;
            gap: 64px;
        }
        @media (max-width: 479px) {
            gap: 32px;
        }
    }

    &__info-block {
        display: flex;
        flex-direction: column;
        gap: 40px;
        @media (max-width: 479px) {
            gap: 20px;
        }
    }

    &__list {
        max-width: 500px;
        width: 100%;

        & li {
            display: flex;
            gap: 10px;
            list-style: none;
            margin-top: 24px;

            &:first-child {
                margin-top: 0;
            }

            @media (max-width: 1023px) {
                margin-top: 8px;
            }

            &:before {
                content: '';
                margin-top: 5px;
                width: 20px;
                height: 20px;
                min-width: 20px;
                display: block;
                border-radius: 100%;
                box-sizing: border-box;
                border: 2px solid rgba(53, 53, 53, 0.3);
                @media (max-width: 1023px) {
                    width: 18px;
                    height: 18px;
                    min-width: 18px;
                    max-width: 18px;
                }
                @media (max-width: 479px) {
                    width: 14px;
                    height: 14px;
                    min-width: 14px;
                    max-width: 14px;
                }
            }
        }
    }
}
</style>